module.exports = __webpack_public_path__ + "static/media/RO.ce48887a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/RO.svg
// module id = 2248
// module chunks = 7